import { render, staticRenderFns } from "./REstatus.vue?vue&type=template&id=a31a8e62&"
import script from "./REstatus.vue?vue&type=script&lang=js&"
export * from "./REstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports